import { Button, tokens } from "@fluentui/react-components";
import HomeOutlineIcon from "~icons/material-symbols/home-outline";
import { memo } from "react";
import { TabsContainer } from "./components/TabsContainer";
import { useAppTabBarStyles } from "./styles";

export type AppTabbarProps = {
  onSelectedAppChange: (tabId: string) => void;
  onHomeButtonClicked: () => void;
  onCloseApp: (appId: string) => void;
  selectedTabId: string;
  tabs: Array<{ id: string; name: string }>;
};

export const AppTabBar = memo(
  ({ tabs, selectedTabId, onSelectedAppChange, onHomeButtonClicked, onCloseApp }: AppTabbarProps) => {
    const styles = useAppTabBarStyles();

    return (
      <div className={styles.container}>
        <Button
          appearance="transparent"
          icon={<HomeOutlineIcon color={tokens.colorBrandForeground1} />}
          onClick={onHomeButtonClicked}
        ></Button>
        <div className={styles.overflowContainer}>
          <TabsContainer
            tabs={tabs}
            selectedTab={selectedTabId}
            onCloseClicked={onCloseApp}
            onTabSelectionChange={onSelectedAppChange}
          />
        </div>
      </div>
    );
  }
);
